<template>
  <modal-notify :isFixed="true" @close="$emit('close')">
    <div slot="header">
      <v-layout>
        <v-flex style="position: absolute; right: 10px; top: 10px">
          <div @click="$emit('close')">
            <img src="/static/img/X.png" alt class="responsive-img pointer" style="height: 20px" />
          </div>
        </v-flex>
      </v-layout>
      <v-layout align-center>
        <v-flex xs10 sm10 md10>
          <Typography
            h2
            bold
            :label="type == 'conversation' ? $t('All conversation') : $t('All Comments')"
          />
        </v-flex>
        <v-flex xs2 sm2 md2>
          <toggle-button
            :value="isToggleAll"
            :sync="true"
            :color="$vuetify.theme.success"
            @change="onChangeStatusAll()"
            :labels="{ checked: 'ON', unchecked: 'OFF' }"
            style="display: inline-block"
          />
        </v-flex>
      </v-layout>
      <v-layout>
        <v-flex>
          <div class="form-control">
            <InputSearch
              class="mt-3 mb-3"
              @clickSearch="onSearch"
              :search="search"
              :placeholder="$t('Search')"
            />
            <!-- <input type="text" v-model="search" :placeholder="$t('Search')" /> -->
          </div>
        </v-flex>
      </v-layout>
    </div>

    <div slot="body">
      <div v-if="loading" class="pt-2 pb-2">
        <scale-loader :color="$vuetify.theme.primary" height="35px" width="7px"></scale-loader>
      </div>
      <template v-else>
        <div
          class="z-border-notification pa-2 my-3"
          v-for="intent in filterIntent"
          :key="'intent_' + intent.id"
        >
          <v-layout wrap class="mb-2">
            <v-flex xs3 sm2 md2 class="text-xs-left">
              <toggle-button
                :value="intent.linenoti_status"
                :sync="true"
                :color="$vuetify.theme.success"
                @change="onChangeLinenotifyStatus(intent.id)"
                :labels="{ checked: 'ON', unchecked: 'OFF' }"
                style="display: inline-block"
              />
            </v-flex>
            <v-flex xs9 sm10 md10>
              <template v-if="intent.intentname == '{default}'">
                <Typography h5 medium :label="$t('Default Conversation')" />
              </template>
              <template v-else-if="intent.intentname == '{welcome}'">
                <Typography h5 medium :label="$t('Welcome Message')" />
              </template>
              <template v-else-if="intent.intentname == '{default_comment_to_inbox}'">
                <Typography h5 medium :label="$t('More Comment to Inbox')" />
              </template>
              <template v-else>
                <Typography h5 medium :label="`${intent.intentname}`" />
              </template>
            </v-flex>
          </v-layout>
          <v-layout wrap>
            <v-flex xs3 sm2 md2 class="text-xs-left"></v-flex>
            <v-flex xs9>
              <div class="form-setting">
                <v-layout class="setting-box pa-2 color-darkBlue">
                  <input
                    type="text"
                    v-model="intent.linenoti_text"
                    :placeholder="$t('Message')"
                    class="mb-0 regular"
                    maxlength="250"
                    @change="onChangeLinenotifyText(intent.id)"
                  />
                </v-layout>
              </div>
            </v-flex>
          </v-layout>
        </div>
      </template>
    </div>

    <div slot="footer" class="text-xs-center">
      <div class="pt-3" style="display: flex; justify-content: center">
        <Button outline :label="$t('cancel')" @click="$emit('close')" />
        <Button depressed :label="$t('Save')" @click="onSaveLineNotify" />
      </div>
    </div>
  </modal-notify>
</template>

<script>
import api from '@/api'
import { mapGetters } from 'vuex'
import ModalNotify from '@/components/elements/ModalNotify'
import ScaleLoader from 'vue-spinner/src/ScaleLoader.vue'
import InputSearch from '@/components/elements/InputSearch.vue'
import { ToggleButton } from 'vue-js-toggle-button'
import Typography from '@/components/elements/Typography.vue'
import Button from '@/components/elements/Button.vue'
import { async } from 'q'
import { DH_CHECK_P_NOT_SAFE_PRIME } from 'constants'
export default {
  props: {
    type: {
      default: 'conversation',
    },
  },
  data: function () {
    return {
      isToggleAll: false,
      loading: true,
      search: {
        nameAll: '',
        group: '',
      },
      click: false,
      allData: [],
      intents: [],
      default_intent: undefined,
    }
  },
  components: {
    ModalNotify,
    ScaleLoader,
    InputSearch,
    ToggleButton,
    Typography,
    Button,
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot',
    }),
    filterIntent: function () {
      var vm = this
      if (vm.search.nameAll != '' && vm.click) {
        vm.click = false
        return (vm.allData = vm.intents.filter(function (el) {
          return el.intentname.toLowerCase().includes(vm.search.nameAll.toLowerCase())
        }))
      } else if (vm.search.nameAll === '' && !vm.click) {
        vm.click = false
        vm.allData.length = []
        return vm.intents
      } else {
        vm.click = false
        return vm.allData.length != 0 ? vm.allData : vm.intents
      }
    },
  },
  mounted: function () {
    var vm = this
    vm.loading = true
    vm.getIntent().then(function () {
      vm.loading = false
    })
  },
  methods: {
    onSearch() {
      var vm = this
      if (vm.search.nameAll != '') {
        vm.click = true
        vm.filterIntent
      }
    },
    onChangeStatusAll: function () {
      var vm = this
      vm.intents.forEach((item, index) => {
        vm.intents[index].isEdit = true
        vm.intents[index].linenoti_status = !vm.isToggleAll
      })
      vm.isToggleAll = !vm.isToggleAll
    },
    onChangeLinenotifyStatus: function (id) {
      var vm = this
      var findIndex = vm.intents.findIndex(function (el) {
        return el.id == id
      })
      if (findIndex > -1) {
        vm.intents[findIndex].isEdit = true
        vm.intents[findIndex].linenoti_status = !vm.intents[findIndex].linenoti_status
      }
    },
    onChangeLinenotifyText: function (id) {
      var vm = this
      var findIndex = vm.intents.findIndex(function (el) {
        return el.id == id
      })
      if (findIndex > -1) {
        vm.intents[findIndex].isEdit = true
      }
    },
    onSaveLineNotify: async function () {
      let vm = this
      vm.$store.dispatch('loading')
      vm.intents.forEach((item, index) => {
        console.log(vm.intents[index].isEdit)
      })
      vm.saveAllLineNotify().then(function () {
        vm.$store.dispatch('loading')
        vm.$emit('close')
      })
    },
    saveAllLineNotify: async function () {
      let vm = this
      try {
        if (vm.filterIntent) {
          var result = await Promise.all(
            vm.filterIntent.map((intent) => vm.precessSaveLineNotify(intent))
          )
        }
        return result
      } catch (error) {
        return error
      }
    },
    precessSaveLineNotify: async function (intent) {
      return await this.saveLineNotify(intent)
    },
    saveLineNotify: function (intent) {
      let vm = this
      return new Promise((resolve, reject) => {
        if (intent.isEdit) {
          let data = {
            pageid: vm.selectedBot.pageid,
            intentname: intent.intentname,
            q_type: intent.q_type,
            q_val: intent.q_val,
            a_type: 'json',
            a_val: intent.a_val.replace(/ /gim, ' '),
            context_in: intent.context_in != null ? intent.context_in : '',
            context_out: intent.context_out != null ? intent.context_out : '',
            quick_reply: intent.quick_reply,
            postidlist: intent.postidlist,
            isShow: true,
            userstatus: intent.userstatus,
            usertags: intent.usertags,
            linenoti_status: intent.linenoti_status,
            linenoti_text: intent.linenoti_text,
          }

          data['id'] = intent.id

          api.editIntent(data, function (error, response) {
            if (error) {
              reject(error)
            }

            resolve()
          })
        } else {
          reject()
        }
      })
    },
    getIntent: function () {
      let vm = this
      let auth = null
      let data = {
        pageid: vm.selectedBot.pageid,
      }

      return new Promise((resolve, reject) => {
        api.getIntent(data, function (error, response) {
          if (error) {
            reject(error)
          }
          if (response.data) {
            var default_intent = null
            var isFoundDefault = false
            $.each(response.data, function (index, val) {
              var intent = val
              intent.isEdit = false
              intent.ableToDelete = true
              if (vm.type == 'conversation' && intent.context_in != 'comment') {
                if (intent.intentname == '{default}') {
                  isFoundDefault = true
                  intent.ableToDelete = false
                  intent.intentname = '{default}'
                  default_intent = intent
                } else if (intent.intentname == '{welcome}') {
                  intent.intentname = '{welcome}'
                  vm.intents.push(intent)
                } else {
                  vm.intents.push(intent)
                }
              } else if (vm.type == 'replycomment' && intent.context_in == 'comment') {
                if (intent.intentname == '{default_comment_to_inbox}') {
                  isFoundDefault = true
                  intent.ableToDelete = false
                  intent.intentname = '{default_comment_to_inbox}'
                  default_intent = intent
                } else {
                  vm.intents.push(intent)
                }
              }
            })

            if (!isFoundDefault) {
              if (vm.type == 'conversation') {
                vm.intents.push({
                  intentname: '{default}',
                  q_type: 'text',
                  a_type: 'json',
                  q_val: '',
                  a_val: '[[]]',
                  context_in: '',
                  context_out: '',
                  ableToDelete: false,
                  isEdit: false,
                })
              } else {
                vm.intents.push({
                  intentname: '{default_comment_to_inbox}',
                  q_type: 'text',
                  a_type: 'json',
                  q_val: '{default}',
                  a_val: [[]],
                  context_in: '',
                  context_out: '',
                  ableToDelete: false,
                  isEdit: false,
                  pageidlist: '',
                  userstatus: '',
                  usertags: '',
                })
              }
            } else {
              vm.intents.push(default_intent)
            }
            vm.isToggleAll = vm.intents.every((item) => item.linenoti_status === true)
            resolve()
          } else {
            reject()
          }
        })
      })
    },
  },
}
</script>

<style lang="scss" scoped>
</style>


// WEBPACK FOOTER //
// src/components/view/billing/ManageSingleLineNotify.vue